import $ from 'jquery';
import _ from 'underscore';
import Constants from 'root/constants';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';
import View_Feedback_List from 'view/user_identification/feedback_list';
import View_Survey_List from 'view/user_identification/survey_list';
import View_Session_List from 'view/user_identification/session_list';
import Model_Session_Recording from 'model/session_recording';

var User_Identification = View.extend({
    className: 'user-identification-info',

    page: 1,
    total_loaded: 0,

    views: {
        feedback_list: {},
        survey_list: {},
        session_list: {}
    },

    events: {
        'click a[href="#overview"]'       : 'onOpenOverview',
        'click a[href="#feedback"]'       : 'onOpenFeedback',
        'click a[href="#survey"]'         : 'onOpenSurvey',
        'click a[href="#session_replay"]' : 'onOpenSessionReplay',
        'click .user-delete'              : 'onDeleteUser',
        'click .prop-delete'              : 'onDeleteProp',
        'click .last-session-watch'       : 'onOpenLastSession'
    },

    dom_handlers: {
        onOpenLastSession: function(e) {
            Modals.openSessionRecording(this.model.get('last_session').id);
        },

        onOpenFeedback: function(e) {
            if (this.views.feedback_list instanceof View_Feedback_List) {
                return;
            }

            this.views.feedback_list = new View_Feedback_List({
                user_identification: this.model.get('identification')
            });

            this.views.feedback_list.render().$el.appendTo(this.$el.find('.region-feedback'));
        },

        onOpenSurvey: function(e) {
            if (this.views.survey_list instanceof View_Survey_List) {
                return;
            }

            this.views.survey_list = new View_Survey_List({
                user_identification: this.model.get('identification')
            });

            this.views.survey_list.render().$el.appendTo(this.$el.find('.region-survey'));
        },

        onOpenSessionReplay: function(e) {
            if (this.views.session_list instanceof View_Session_List) {
                return;
            }

            this.views.session_list = new View_Session_List({
                user_identification: this.model.get('identification')
            });

            this.views.session_list.render().$el.appendTo(this.$el.find('.region-session'));
        },

        onDeleteUser: function(e) {
            Modals.deleteUserIdentification(this.model);
        },

        onDeleteProp: function(e) {
            e.preventDefault();

            var key = $(e.currentTarget).data('val');

            Modals.deleteUserIdentificationKey(this.model.id, key);
        }
    },

    initialize: function() {
        this.listenTo(this.model, 'change', this.renderProperties);
        this.listenTo(this.model, 'change', this.renderAverageRating);
        this.listenTo(this.model, 'change', this.renderLastSession);
    },

    loadOverview: function() {
        Cache.app.request({
            action: 'user_identification/overview',
            context: this,
            data: {
                id: this.model.id
            },
            success: function(response) {
                this.model.set({
                    average_rating : response.rating,
                    average_nps    : response.nps,
                    last_session   : response.last_session
                });
            }
        });
    },

    loadProperties: function() {
        Cache.app.request({
            action: 'user_identification/load',
            data: {
                identifications: [this.model.get('identification')]
            },
            success: (response) => {
                this.model.set(response[0]);
            }
        });
    },

    renderLastSession: function() {
        if (!this.model.get('last_session')) {
            return;
        }

        var model = new Model_Session_Recording(this.model.get('last_session'));

        var duration = model.getDuration();

        var html =
        '<div class="section-heading">Last Session</div>' +
        (this.model.get('last_session') ?
        '<div class="last-session-watch"><i class="fa-solid fa-circle-play"></i> Watch' + (duration === '00:00' ? '' :  ' (' + duration + ')') + '</div>' +
        '<div class="last-session-properties">' +
            '<div><i class="fa-regular fa-fw fa-globe tooltip" data-title="Domain"></i></div>' +
            '<div>' + model.escape('domain') + '</div>' +

            '<div><i class="fa-regular fa-fw fa-computer tooltip" data-title="System"></i></div>' +
            '<div>' + model.getOSIcon() + ' ' +  model.getOSName() + '</div>' +

            '<div><i class="fa-regular fa-fw fa-browser tooltip" data-title="Browser"></i></div>' +
            '<div>' + model.getBrowser() + '</div>' +

            '<div><i class="fa-regular fa-fw fa-location-dot tooltip" data-title="Location"></i></div>' +
            '<div>' +
                (this.model.escape('last_location') || '-') +
                '<div class="text-info text-small margin-top-4">' + Util.moment(this.model.get('last_seen'), 'DD MMM YYYY hh:mm A') + '</div>' +
            '</div>' +
        '</div>' :
        '<div class="no-data-captured">No session replay captured</div>');

        this.$el.find('.region-last-session').html(html);
    },

    renderProperties: function() {
        var user_properties = '';

        if (this.model.get('props')) {
            _.each(this.model.get('props'), function(user_value, user_key) {
                user_properties +=
                '<div class="text-info">' + Util.htmlEntities(user_key) + '</div>' +
                '<div>' + Util.htmlEntities(user_value) + '</div>' +
                '<div>' +
                    '<a href="#" class="prop-delete text-icon" data-val="' + Util.htmlEntities(user_key) + '"><i class="fa-solid fa-delete-left"></i></a>' +
                '</div>';
            });
        } else {
            this.loadProperties();

            user_properties +=
            '<div>' +
                '<div class="loader-placeholder" style="width:80%;"></div>' +
                '<div class="loader-placeholder"></div>' +
            '</div>' +
            '<div>' +
                '<div class="loader-placeholder" style="width:80%;"></div>' +
                '<div class="loader-placeholder"></div>' +
            '</div>';
        }

        var html =
        '<div class="section-heading">Properties</div>' +
        (user_properties ?
        '<div class="user-properties">' + user_properties + '</div>' :
        '<div class="no-data-captured">No custom properties added</div>');

        this.$el.find('.region-properties').html(html);
    },

    renderAverageRating: function() {
        var html =
        '<div class="box-neutral">' +
            '<div class="font-weight-medium">Rating</div>' +
            '<div class="average-rating">' +
                (this.model.get('average_rating') !== undefined ?
                '<div class="icon"><i class="fas fa-star-sharp"></i></div>' + (this.model.get('average_rating') !== null ? this.model.get('average_rating') : '-') :
                '<div class="loader-placeholder margin-top-8 float-right" style="width:80px;"></div>') +
            '</div>' +
        '</div>' +
        '<div class="box-neutral">' +
            '<div class="font-weight-medium">NPS</div>' +
            '<div class="average-nps">' +
                (this.model.get('average_nps') !== undefined ?
                (this.model.get('average_nps') !== null ? this.model.get('average_nps') : '-') :
                '<div class="loader-placeholder margin-top-8 float-right" style="width:80px;"></div>') +
            '</div>' +
        '</div>';

        this.$el.find('.region-average-rating').html(html);
    },

    render: function() {
        var workspace_member = Cache.getRealWorkspaceMember();

        var content =
        (Cache.app.isAdmin() ?
        '<div class="button-dropdown sidebar-actions">' +
            '<button type="button" class="ellipsis"><i class="fa-regular fa-ellipsis-h"></i></button>' +
            '<div>' +
                '<ul class="dropdown">' +
                    '<li class="user-delete">Delete</li>' +
                '</ul>' +
            '</div>' +
        '</div>' : '') +

        '<div class="region-basic">' +
            '<div class="flex-start">' +
                '<img class="user-32" src="' + Util.gravatar(this.model.get('email', 32, this.model.get('display_name'))) + '">' +
            '</div>' +
            '<div class="user-info">' +
                '<div class="user-info-primary">' + (this.model.escape('display_name') || '-' ) + '</div>' +
                '<div class="user-info-secondary">' + (this.model.escape('email') || '-') + '</div>' +
            '</div>' +
        '</div>' +

        '<div class="tab">' +
            '<div class="tab-menu">' +
                '<a href="#overview" class="active">Overview</a>' +
                '<a href="#feedback">Feedback</a>' +
                '<a href="#survey">Survey</a>' +

                (Cache.account.hasFeature('full_session_recording') && workspace_member.hasAccess(Constants.ACCESS_SESSION_REPLAY, 0) ?
                '<a href="#session_replay">Session</a>' : '') +
            '</div>' +
            '<div class="tab-content">' +
                '<div class="region-overview active">' +
                    '<div class="region-average-rating grid-6-6 grid-gap-16"></div>' +
                    '<hr class="small">' +
                    '<div class="region-last-session"></div>' +
                    '<div class="region-properties"></div>' +
                '</div>' +
                '<div class="region-feedback"></div>' +
                '<div class="region-survey"></div>' +

                (Cache.account.hasFeature('full_session_recording') && workspace_member.hasAccess(Constants.ACCESS_SESSION_REPLAY, 0) ?
                '<div class="region-session"></div>' : '') +
            '</div>' +
        '</div>';

        this.$el.html(content);

        this.renderAverageRating();
        this.renderLastSession();
        this.renderProperties();

        if (!this.model.get('average_rating')) {
            this.loadOverview();
        }

        return this;
    }
});

export default User_Identification;
